import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import Tasks from './pages/tasks';
import Templates from './pages/Templates';
import Admin from './pages/Admin';
import Notifications from './pages/Notifications';
import DepartmentDetail from './pages/DepartmentDetail';
import Suggestions from './pages/Suggestions';
import Departments from './pages/Departments';
import UserDashboards from './pages/UserDashboards';
import Teams from './pages/Teams';
import TeamDetail from './pages/TeamDetail';
import DailyRoutines from './pages/DailyRoutines';
import DayOpening from './pages/DayOpening';
import DaySummary from './pages/DaySummary';
import TeamSummaries from './pages/TeamSummaries';
import ResourceManager from './pages/ResourceManager';
import SopInstanceViewer from './pages/SopInstanceViewer';
import TeamAvailability from './pages/TeamAvailability';
import ManagerDashboard from './pages/ManagerDashboard';

function App() {
  // הסרנו את useAuth מכאן - זה היה הבעיה!
  
  return (
    <Router>
      <AuthProvider>
        <DataProvider>
          <div className="min-h-screen bg-gray-50" dir="rtl">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
                <Route index element={<Navigate to="/dashboard" />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="projects" element={<Projects />} />
                <Route path="projects/:id" element={<Projects />} />
                <Route path="departments" element={<Departments />} />
                <Route path="departments/:id" element={<DepartmentDetail />} />
                <Route path="teams" element={<Teams />} />
                <Route path="teams/:id" element={<TeamDetail />} />
                <Route path="/team-availability" element={<TeamAvailability />} />
                <Route path="daily-routines" element={<DailyRoutines />} />
                <Route path="/day-opening" element={<DayOpening />} />
                <Route path="/day-summary" element={<DaySummary />} />
                <Route path="team-summaries" element={<TeamSummaries />} />
                <Route path="tasks" element={<Tasks />} />
                <Route path="tasks/:id" element={<Tasks />} />
                <Route path="templates" element={<Templates />} />
                <Route path="admin" element={<Admin />} />
                <Route path="user-dashboards" element={<UserDashboards />} />
                <Route path="notifications" element={<Notifications />} />
                <Route path="suggestions" element={<Suggestions />} />
                
                {/* נתיבי SOP - בלי כפילויות */}
                <Route path="resources" element={<ResourceManager />} />
                <Route path="sop-instance/:instanceId" element={<SopInstanceViewer />} />
                <Route path="manager-dashboard" element={<ManagerDashboard />} />
              </Route>
            </Routes>
          </div>
        </DataProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;